import {
  useInfiniteQueryUserLibraryContinueSeries,
  useInfiniteQueryULContinueSeriesV2,
  useKeyUserLibraryContinueSeries,
  useKeyULContinueSeriesV2,
  useKeyUserLibraryMyList,
  useKeyULMyListV3,
  useQueryUserLibraryContinueSeries,
  useQueryULContinueSeriesV2,
} from '@ifit/gateway-wolf-athenaeum-service';
import { useInfiniteQueryOptions, useRowQueryOptions } from '../query-options';
import { useInvalidateOnCallJavaScript } from '../native-bridge-refresh';
import getNextPageParam from '../get-next-page';
import { useInfiniteQueryDataMemo } from '../query-memo';
import { useEquipmentType } from '../equipment-type';
import { useModality } from '../use-modality';
import { useFeatureFlags } from '../../../helpers/good-cop-helper';

const featureFlag = 'featureflag://flag?key=challenge-store&type=bool';

export const useContinueSeriesRowQuery = (enabled: boolean) => {
  const opts = useRowQueryOptions();

  useInvalidateOnCallJavaScript(
    'RefreshFavorites',
    useKeyUserLibraryContinueSeries,
  );
  return useQueryUserLibraryContinueSeries({ ...opts }, { enabled });
};

export const useContinueSeriesRowQueryV2 = (enabled: boolean) => {
  const { equipmentType, isLoading } = useEquipmentType();
  const modality = useModality(equipmentType);
  const isEnabled = !!enabled && !isLoading;
  const opts = { ...useRowQueryOptions(), modality };
  useInvalidateOnCallJavaScript('RefreshFavorites', useKeyULContinueSeriesV2);
  return useQueryULContinueSeriesV2({ ...opts }, { enabled: isEnabled });
};

export const useGetContinueSeriesRow = () => {
  const featureFlags = useFeatureFlags([featureFlag]);
  const v2Enabled = featureFlags[featureFlag]
    ? (featureFlags[featureFlag] as boolean)
    : false;

  const v2Results = useContinueSeriesRowQueryV2(v2Enabled);
  const results = useContinueSeriesRowQuery(!v2Enabled);
  return v2Enabled ? v2Results : results;
};

export const useContinueSeriesInfiniteQuery = (enabled: boolean) => {
  const opts = useInfiniteQueryOptions();
  useInvalidateOnCallJavaScript('RefreshFavorites', useKeyUserLibraryMyList);

  useInvalidateOnCallJavaScript(
    'RefreshFavorites',
    useKeyUserLibraryContinueSeries,
  );
  return useInfiniteQueryDataMemo(
    useInfiniteQueryUserLibraryContinueSeries(
      { ...opts },
      { getNextPageParam, enabled },
    ),
  );
};

export const useContinueSeriesInfiniteQueryV2 = (enabled: boolean) => {
  const { equipmentType, isLoading } = useEquipmentType();
  const modality = useModality(equipmentType);
  const opts = { ...useInfiniteQueryOptions(), modality };
  const isEnabled = !!enabled && !isLoading;
  useInvalidateOnCallJavaScript('RefreshFavorites', useKeyULMyListV3);
  useInvalidateOnCallJavaScript('RefreshFavorites', useKeyULContinueSeriesV2);
  return useInfiniteQueryDataMemo(
    useInfiniteQueryULContinueSeriesV2(
      { ...opts },
      { getNextPageParam, enabled: isEnabled },
    ),
  );
};

export const useGetContinueSeries = () => {
  const featureFlags = useFeatureFlags([featureFlag]);
  const v2Enabled = featureFlags[featureFlag]
    ? (featureFlags[featureFlag] as boolean)
    : false;
  const v2Results = useContinueSeriesInfiniteQueryV2(v2Enabled);
  const results = useContinueSeriesInfiniteQuery(!v2Enabled);
  return v2Enabled ? v2Results : results;
};
